import { BlurView } from 'expo-blur';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, Pressable, ActivityIndicator, Image, ScrollView } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import image1 from '../../assets/images/howToPlay1.png';
import image2 from '../../assets/images/howToPlay2.png';
import image3 from '../../assets/images/howToPlay3.png';
import image4 from '../../assets/images/howToPlay4.png';
import { styles } from './styles';

const InstructionsCard = ({ setRenderRanking, handlePlay }) => {
  const { width, height } = useSafeAreaFrame();

  const [cardSlide, setCardSlide] = useState(1);

  const handleButtonPress = useCallback(() => {
    if (cardSlide === 1) {
      setCardSlide(2);
    }
    if (cardSlide === 2) {
      setCardSlide(3);
    }
    if (cardSlide === 3) {
      setCardSlide(4);
    }
    if (cardSlide === 4) {
      handlePlay();
    }
  }, [cardSlide]);

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Pressable
          style={styles.pressableBackground}
          onPress={() => {
            setRenderRanking(false);
          }}
        />

        <View style={styles.container}>
          <Text style={styles.title}>Como Jogar?</Text>

          {cardSlide === 1 && (
            <>
              <Image source={image1} style={styles.image1} />
              <Text style={styles.textDescription}>
                Clique nas fachadas para revelar o que têm dentro do prédio
              </Text>
            </>
          )}

          {cardSlide === 2 && (
            <>
              <Image source={image2} style={styles.image2} />
              <Text style={styles.textDescription}>
                O jogo trás perguntas sobre metais, ligas metálicas e minerais. encontre os objetos
                para testar seu conhecimento.
              </Text>
              <Text style={styles.textDescription2}>(nem todos os objetos são interativos)</Text>
            </>
          )}

          {cardSlide === 3 && (
            <>
              <Image source={image3} style={styles.image3} />
              <Text style={styles.textDescription}>
                Você têm 2:30 minutos para encontrar e responder perguntas sobre 12 objetos no
                total. Se você acertar o objeto ficará verde, caso erre ele ficará vermelho
              </Text>
            </>
          )}

          {cardSlide === 4 && (
            <>
              <Image source={image4} style={styles.image4} />
              <Text style={styles.textDescription}>
                Ao encontrar todos os objetos ou ao esgotar o tempo você descobrirá sua pontuação e
                poderá salvá-la no ranking.
              </Text>
            </>
          )}

          <Pressable
            onPress={() => {
              handleButtonPress();
            }}
            style={styles.button}>
            <Text style={styles.textButton}>{cardSlide !== 4 ? 'Próximo' : 'Jogar'}</Text>
          </Pressable>
        </View>
      </BlurView>
    </View>
  );
};

export default InstructionsCard;
